import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'
import { ReviewTopicsScopeParams } from 'src/services/reviewAnalysisApi/interfaces/reviewAnalysis.interface'

// One topic's AI summary + quotes for the widget's click-through detail panel.
// Lazy by design: pass name='' (disabled) until a topic is selected.
export const useGetReviewAnalysisTopicDetailQuery = (
  campaignId: string,
  name: string,
  scope: ReviewTopicsScopeParams = {}
) =>
  useQuery({
    enabled: !!campaignId && !!name,
    queryFn: () =>
      ReviewAnalysisApiService.getTopicDetail(campaignId, name, scope),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_TOPIC_DETAIL,
      campaignId,
      name,
      scope.facilityId ?? '',
      (scope.facilityIds ?? []).join(','),
      scope.platform ?? '',
      scope.venueName ?? '',
      scope.range?.from ?? '',
      scope.range?.to ?? '',
    ],
  })
